<template>
	<div id="login" class="app flex-row text-center">
		<img class="logo" :src="config.Params.MainLogo"><br>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-12">
					<div class="card-group">
						<div class="card p-4">
							<div class="card-body">
								<h1>Login</h1>
								<p class="text-muted">Sign In to your {{ SiteName }} Administrative Account</p>
								<el-form ref="loginForm" label-position="top" :model="user" label-width="120px" @submit.native.prevent>
									<el-form-item
                                        prop="username"
                                        :rules="[
                                            { required: true, message: 'Email is required'},
                                            { type: 'email',  message: 'Email is invalid', trigger: 'blur'}

                                        ]"
                                    >
	                                    <el-input placeholder="Email" v-model="user.username">
	                                        <template #prepend><i class="fas fa-user"></i></template>
	                                    </el-input>
	                                </el-form-item>
									<el-form-item
                                        prop="password"
                                        :rules="[
                                            { required: true, message: 'Password is required'}

                                        ]"
                                    >
	                                    <el-input placeholder="Password" type="password" v-model="user.password"  @keyup.enter.native="login">
	                                        <template #prepend><i class="fas fa-lock"></i></template>
	                                    </el-input>
	                                </el-form-item>
                                    <div class="row text-center">
                                        <div class="col-12">
                                            <button type="button" class="btn px-4 btn-primary loginButton" v-on:click="login()">Login</button>
                                        </div>
                                    </div>
	                            </el-form>
							</div>
							<div class="row justify-content-center">
								<div v-if="0==1" class="sociallogin_sources col-12">
									<div class="login_with"><div class="login_with_text">or Login with</div></div>
									<div class="row justify-content-center">
									<div class="sociallogin_group col-6">
		                                <div class="flR loginSource_twitter login_source" data-loginsource="twitter" @click="socialLogin('twitter')">
			                                <img class="socialLogin_icon" src="../assets/images/twitter.svg">
			                                <span class="socialLogin_text">Twitter</span>
			                            </div>
		                                <div class="flR loginSource_facebook fb-login-button login_source" data-loginsource="facebook" @click="socialLogin('facebook')">
			                                <img class="socialLogin_icon" src="../assets/images/facebook.svg">
			                                <span class="socialLogin_text">Facebook</span>
			                            </div>
			                        </div>
			                        <div v-if="0==1" class="sociallogin_group col-6">
		                                <div  class="flL loginSource_linkedin login_source customLinkedin" data-loginsource="linkedin" @click="socialLogin('linkedin')">
			                                <img class="socialLogin_icon" src="../assets/images/linkedin.svg">
			                                <span class="socialLogin_text">Linkedin</span>
			                            </div>
		                                <div id="loginSource_googleplus" class="flL loginSource_googleplus login_source customGPlusSignIn" data-loginsource="googleplus" @click="socialLogin('googleplus')">
			                                <img class="socialLogin_icon" src="../assets/images/google-plus.svg">
			                                <span class="socialLogin_text">Google</span>
			                            </div>
		                            </div>
		                            </div>
	                            </div>
							</div>
							<div class="row">
								<div class="text-left col-7 forgotPassword">
                                    <a href="javascript:;" v-on:click.stop="gotoForgotPassword" >Forgot password?</a>
                                </div>
                            </div>
						</div>
						<div class="card text-white bg-primary py-5 d-md-down-none" style="width: 44%;">
							<ContactUs ref="contactus" :show="showContactUsForm" :caller="'login'" @close="showContactUsForm = false"></ContactUs>
							<div class="card-body text-center">
								<div>
									<h2>Welcome</h2>
									<img v-if="config.ClientLogo" class="client-logo" :src="config.ClientLogo">
									<div style="width: 100%" v-html="WelcomeText"></div>
									<button type="button" class="btn active mt-3 btn-light" v-on:click.stop="showContactUs">Contact Us</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import ContactUs from './global/ContactUs.vue';
import Util from '../assets/js/util.js';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
	name: 'Login',
	data() {
		return {
			currentStatus: 0,
			user : {
				username: '',
	            password: ''
	        },
	        showContactUsForm: false,
			WelcomeText : 'Welcome to our Admin Site.  If you have a login, please use it now, otherwise, contact us for access details.'
		}
	},
	props:["config"],
    components: {
        ContactUs
    },
	computed: {
		...mapGetters({ currentUser: 'currentUser' }),
		SiteName() {
			return this.config.Params.SiteName
		}
	},
	created () {
		this.checkCurrentLogin()
	},
	methods: {
	    checkCurrentLogin () {
			if (this.currentUser) {
                //console.log('Thinks Logged in');
				//this.$router.replace(this.$route.query.redirect || '/dashboard')
			}
        },
        showContactUs () {
            this.showContactUsForm = Math.random();
        },

	    login() {
            if (this.currentStatus == STATUS_SAVING) {
                return true;
            }
            this.$refs['loginForm'].validate((valid) => {
            	if (valid) {
	                this.currentStatus = STATUS_SAVING;
					axios.post('/Login/Validation', {
						username: this.user.username,
						password: this.user.password,
					}).then(response => {
						if (response.data.result == 'success') {
			                this.loginSuccessful(response);
		                } else {
		                    this.loginFailed()
							this.displayPopup (response.data.message);
							this.user.password = '';
		                }
					}).catch(response => {
						this.loginFailed();
					});

		        } else {
		            this.displayPopup ('Please enter both a valid Email and a Password');
		        }
		    });
	    },
		loginSuccessful (response) {
			if (!response.data.token) {
				this.loginFailed()
				return;
			}
			this.currentStatus = STATUS_SUCCESS;
			this.error = false;
			localStorage.subdomain = this.config.SubDomain;
			localStorage.token = response.data.token;
			localStorage.RoleSecurity = JSON.stringify(response.data.RoleSecurity);
			if (response.data.super && response.data.super == 'y') {
				localStorage.Super = 'y';
			} else {
				localStorage.Super = '';
			}

			Util.createCookie('login', 'y');
			//Cookies.set('login', 'y', { domain: 'analyzer.valley' });
			this.$store.dispatch('login');
			let returnURL = localStorage.returnURL;
			delete localStorage.returnURL;
			if (!returnURL || returnURL == '/logout' || returnURL.toLowerCase().indexO('login') !== -1) {
				this.$router.replace('/dashboard');
			} else if (returnURL.indexOf('http') === -1) {
				this.$router.replace(returnURL);
			} else {
				location.href = returnURL;
			}
		},
		loginFailed () {
			this.currentStatus = STATUS_FAILED;
			this.$store.dispatch('logout');
			delete localStorage.token;
			Util.eraseCookie('login');
		},
		gotoForgotPassword () {
			this.$router.replace('/forgotpassword');
		},
        displayPopup (message) {
			this.$alert(message, 'Login Error', {
				confirmButtonText: 'OK',
			});
        },
	},
	updated () {
		this.checkCurrentLogin();
	},
	mounted () {
		if (this.$route.query.msg) {
			this.$notify({
				title: '',
				message: "You have been logged out",
				type: 'warning',
				duration: 2000,
				showClose: false
			});
	    }

		let self = this;

		let subdomain = localStorage.subdomain;
		localStorage.clear();
		localStorage.subdomain = subdomain;
		axios.post('/systemtext/get', {SystemTextID : 'loginwelcome'}
		)
			.then(response => {
				if (response.data.result == 'success') {
					if (response.data.SystemText) {
						this.WelcomeText = response.data.SystemText.SystemText;
					}
				}
			}).catch(response => {

		});
	}
}

</script>
<style >

@media (max-width: 991.98px) {
	.d-md-down-none {
        display: none!important;
    }
}
#app.login, #app.clientlogin {
  margin-top: 0px;
	height: 100%;
	background-color: #000;
}

#login .logo {
	max-width: 50%;
	max-height: 250px;
	margin-top: 20px;
}
#login .client-logo {
	max-width: 50%;
	max-height: 200px;
	margin-top: 15px;
	margin-bottom: 15px;
}

#login .card-body p, .card-body h2 {
	color: #fff;
}
#login .align-items-center {
	text-align:center;
}
#app.login .page-wrapper, #app.clientlogin .page-wrapper {
	margin-left: 0px;
	margin-top: 0px;
	background-color: #000;
}
#login .card-body {
	padding: 0px 20px;
}

.loginButton {
	width: 80%;
	margin-bottom: 10px;
}
forgotPassword {
	border-top: 1px solid #F4F6F9;
}
div.sociallogin_sources {
    position: relative;
    margin-top: 15px;
    min-height: 110px;
    border-top: 1px solid #F4F6F9;
    position: relative;
    padding-top: 16px;
    text-align:left;
    width: 100%;
}
.login_with {
    position: absolute;
    top: -14px;
    left: 50%;
}
.login_with_text {
    position: relative;
    width: auto;
    background-color: #ffffff;
    left: -50%;
    text-align: center;
    color: #999999;
}
.login_source {
    border-radius: 2px;
    width: auto;
    display: block;
    padding: 9px 10px 4px 9px;
    cursor: pointer;
    margin-bottom: 10px;
    width: 170px;
}

.login_source .socialLogin_icon {
    height: 15px;
    margin: 5px;
    position: relative;
    top: -3px;
}
.login_source .socialLogin_text {
    color: #fff;
    font-size: 16px;
    font-weight: 800;
    margin: 0px 0px 0px 10px;
}
.flL {
    margin-left: 10px;
}
.flR {
    float: right;
    margin-right: 10px;
	clear:right;
}
.loginSource_twitter {
	background-color: #55ACE9;
}
.loginSource_facebook {
	background-color: #3C5B9B;
}
.loginSource_linkedin {
    background-color: #0077b5;
}
.loginSource_googleplus {
    background-color: #dd4b39;
}
.sociallogin_group {
	padding: 5px;
}
@media (max-width: 550px) {
	.login_source {
	    width: 140px;
	}
	.flR {
	    margin-right: 3px;
	}
	.flL {
	    margin-left: 3px;
	}
	.sociallogin_group {
		padding: 0px;
	}
	#login .card-body {
        padding: 0px;
    }
	.card {
		margin-top: 0px;
	}
	.container {
		padding-left: 0px;
		padding-right: 0px;
	}
	.card-group {
		min-width: 310px;
	}
}
</style>
